import React from 'react';
import { RecordIconBase } from './view';

export const RecordIcon = () => {
    return <RecordIconBase icon="icScreenRecording" color="none" size={16} />;
};
